//just for backwards compatibility with MDC2.0
import _ImportForm from '../actionElement/ImportForm';
export const ImportForm = _ImportForm;
export default { ImportForm };
